<template>
  <div class="w-full">
    <label class="label" :for="field">
      {{ label }}
    </label>
    <input v-if="maskFormat" v-mask="maskFormat" v-validate="validationRule" :name="field" :class="{'field': true, 'border-grey-lighter': !errors.has(field),'border-red': errors.has(field), 'field-disabled': disabled }" :id="field" type="text" :placeholder="placeholder" v-model="fieldModel" :disabled="disabled == 1">
    <input v-else v-validate="validationRule" :name="field" :class="{'field': true, 'border-grey-lighter': !errors.has(field),'border-red': errors.has(field), 'field-disabled': disabled }" :id="field" type="text" :placeholder="placeholder" v-model="fieldModel" :disabled="disabled == 1">
    <p v-if="fieldType !== 'date' && errors.has(field)" class="text-red text-xs italic mt-3">{{ validationMessage }}</p>
    <!-- errors.first(field) is null to begin with, and will have the first error - we need custom error message, working with the existence of the word 'before' -->
    <p v-if="fieldType === 'date' && errors.has(field)" class="text-red text-xs italic mt-3">{{ errors.first(field) && errors.first(field).indexOf('before') > -1 ? validationMessage : 'Please enter a valid date of birth in this format: DD/MM/YYYY' }}</p>
  </div>
</template>

<script>
import _ from 'lodash';
import { mask } from 'vue-the-mask';

export default {
  name: 'FieldText',
  inject: ['$validator'],
  directives: { mask },
  props: {
    maskFormat: {
      type: String,
    },
    fieldType: {
      type: String,
    },
    namespace: {
      type: String,
    },
    field: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    validationRule: {
      default: '',
    },
    validationMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldModel: {
      get() {
        // console.log('error', this.field, this.errors.has(this.field));
        return _.get(this.$store.state[this.namespace], this.field);
      },
      set(value) {
        this.$store.commit(`${this.namespace}/setField`, {
          field: this.field,
          value,
        });
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FieldText.vue